export const ReservationTypes = {
    Anyone: 'anyone',
    Request: 'request',
    Disable: 'disable',
};
export var TopicEnumJa;
(function (TopicEnumJa) {
    TopicEnumJa[TopicEnumJa["\u6599\u7406"] = 0] = "\u6599\u7406";
    TopicEnumJa[TopicEnumJa["\u8AAD\u66F8"] = 1] = "\u8AAD\u66F8";
    TopicEnumJa[TopicEnumJa["\u30B9\u30DD\u30FC\u30C4"] = 2] = "\u30B9\u30DD\u30FC\u30C4";
    TopicEnumJa[TopicEnumJa["\u6B74\u53F2"] = 3] = "\u6B74\u53F2";
    TopicEnumJa[TopicEnumJa["\u97F3\u697D"] = 4] = "\u97F3\u697D";
    TopicEnumJa[TopicEnumJa["\u82B8\u8853"] = 5] = "\u82B8\u8853";
    TopicEnumJa[TopicEnumJa["\u54F2\u5B66"] = 6] = "\u54F2\u5B66";
    TopicEnumJa[TopicEnumJa["\u65C5\u884C"] = 7] = "\u65C5\u884C";
    TopicEnumJa[TopicEnumJa["\u793E\u4F1A"] = 8] = "\u793E\u4F1A";
})(TopicEnumJa || (TopicEnumJa = {}));
export var TopicEnumEn;
(function (TopicEnumEn) {
    TopicEnumEn[TopicEnumEn["Cooking"] = 0] = "Cooking";
    TopicEnumEn[TopicEnumEn["Reading"] = 1] = "Reading";
    TopicEnumEn[TopicEnumEn["Sports"] = 2] = "Sports";
    TopicEnumEn[TopicEnumEn["History"] = 3] = "History";
    TopicEnumEn[TopicEnumEn["Music"] = 4] = "Music";
    TopicEnumEn[TopicEnumEn["Art"] = 5] = "Art";
    TopicEnumEn[TopicEnumEn["Philosophy"] = 6] = "Philosophy";
    TopicEnumEn[TopicEnumEn["Travel"] = 7] = "Travel";
    TopicEnumEn[TopicEnumEn["Society"] = 8] = "Society";
})(TopicEnumEn || (TopicEnumEn = {}));
export var ExpirePreference;
(function (ExpirePreference) {
    ExpirePreference[ExpirePreference["Never"] = 0] = "Never";
    ExpirePreference[ExpirePreference["SixHour"] = 1] = "SixHour";
    ExpirePreference[ExpirePreference["Hour"] = 2] = "Hour";
    ExpirePreference[ExpirePreference["HalfHour"] = 3] = "HalfHour";
})(ExpirePreference || (ExpirePreference = {}));
export const ExpirePreferenceLabel = {
    [ExpirePreference.Never]: '自動取り消ししない',
    [ExpirePreference.SixHour]: '6時間前に自動取り消し',
    [ExpirePreference.Hour]: '1時間前に自動取り消し',
    [ExpirePreference.HalfHour]: '30分前に自動取り消し',
};
